var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-btn"},[_vm._t("hoverBtn"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"dropdown"},[_c('div',{staticClass:"default-dropdown"},[_vm._t("down")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }